import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import './RegistrationSuccess.scss';

const RegistrationSuccess = () => {
  const registeredEmail = useGlobalState((state) => state.app.registeredEmail);

  return (
    <div className="registration-success">
      <Text tag="h4">Thank you for creating an account!</Text>
      <Text tag="p">
        We’ve sent you a verification email at {registeredEmail}. Please check your email, in order to verify the
        account.
      </Text>
    </div>
  );
};

export default RegistrationSuccess;
